import { MarkdownBlockClientData } from '@yandex-int/k-common/typings/api/models/main-page';
import { Text, H3, useAppContext } from 'platform-components';
import { UI_KIT_HEADER_TYPOGRAPHY } from 'platform-components/src/components/constants';
import React from 'react';

import { WidgetWrapper } from 'common.components/widgets.widget-wrapper/widget-wrapper';

import './markdown.scss';

interface Props {
    data: MarkdownBlockClientData;
}

export const MarkdownWidget = (props: Props) => {
    const { data } = props;
    const { title, additional_info: additionalInfo } = data;
    const markdownBlocks = additionalInfo?.markdown || [];

    const { uatraits } = useAppContext();
    const isMobile = uatraits.isMobile;

    return (
        <div className="markdown-widget">
            {title && (
                <H3 mix="markdown-widget__title" typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMMedium}>
                    {title}
                </H3>
            )}
            {markdownBlocks.map((mdBlock) => {
                const {
                    id,
                    color,
                    background_color: backgroundColor,
                    content,
                    mobile_content: mobileContent,
                } = mdBlock;

                const md = isMobile ? mobileContent || content : content;

                return (
                    <WidgetWrapper background={backgroundColor} fullWidth key={id}>
                        {md && (
                            <Text color={color} type={Text.TYPE.MARKDOWN}>
                                {md}
                            </Text>
                        )}
                    </WidgetWrapper>
                );
            })}
        </div>
    );
};
